/* CrispyBug - Effets saisonniers maison (remplace l'app « 3D Seasonal Effects »).
 * Vanilla JS, sans dépendance, tous les visuels en SVG/CSS générés ici.
 *
 * Config injectée par snippets/cb-seasonal.liquid (réglages « Paramètres du thème ») :
 *   window.CB_SEASONAL = { enabled, mode, preset, calendar, fall:{...}, deco:{...}, ... }
 * Les décos du haut (coins, suspendus, personnage haut-gauche) laissent passer les clics
 * (elles recouvrent le header) ; seules celles du bas se masquent au clic.
 * Forçage pour test/aperçu : ?cbs=<preset> (ex. ?cbs=noel) ou ?cbs=off.
 *
 * Ambiances : halloween, noel, hiver, black_friday, soldes, saint_valentin, paques,
 *             printemps, ete, automne, nouvel_an.
 */
(function () {
  "use strict";
  if (window.__CBS_LOADED) return;
  window.__CBS_LOADED = true;

  var C = window.CB_SEASONAL || {};
  var Q = (location.search.match(/[?&]cbs=([a-z_]+)/) || [])[1];

  // --------------------------------------------------------------------------
  // Utilitaires
  // --------------------------------------------------------------------------
  function svgUri(svg) { return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg); }
  function svg(vb, body) { return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + vb + '">' + body + "</svg>"; }
  function num(v, d) { v = parseFloat(v); return isNaN(v) ? d : v; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function pick(a) { return a[(Math.random() * a.length) | 0]; }

  // --------------------------------------------------------------------------
  // Bibliothèque de dessins (SVG maison)
  // --------------------------------------------------------------------------
  var ART = {};

  ART.cobweb = function (color) {
    var g = "", a, i, r, d;
    for (i = 0; i <= 6; i++) { a = i * 15 * Math.PI / 180; g += '<line x1="0" y1="0" x2="' + (140 * Math.cos(a)).toFixed(1) + '" y2="' + (140 * Math.sin(a)).toFixed(1) + '"/>'; }
    for (r = 18; r <= 126; r += 18) {
      d = "M" + r + " 0";
      for (i = 1; i <= 6; i++) { a = i * 15 * Math.PI / 180; d += " Q" + ((r * .8) * Math.cos(a - .13)).toFixed(1) + " " + ((r * .8) * Math.sin(a - .13)).toFixed(1) + " " + (r * Math.cos(a)).toFixed(1) + " " + (r * Math.sin(a)).toFixed(1); }
      g += '<path d="' + d + '"/>';
    }
    return svg("0 0 130 130", '<g fill="none" stroke="' + color + '" stroke-opacity=".85" stroke-width="1.1">' + g + "</g>" +
      '<line x1="96" y1="0" x2="96" y2="64" stroke="' + color + '" stroke-width=".8"/>' + ART.spiderBody(96, 72, .55));
  };

  ART.spiderBody = function (cx, cy, s) {
    var legs = "", i, side, y;
    for (i = 0; i < 4; i++) {
      y = cy - 6 + i * 5;
      for (side = -1; side <= 1; side += 2) {
        legs += '<path d="M' + cx + " " + y + " Q" + (cx + side * 16) + " " + (y - 10 + i * 3) + " " + (cx + side * 24) + " " + (y + 6 + i * 2) + '" stroke="#111" stroke-width="3" fill="none" stroke-linecap="round"/>';
      }
    }
    return '<g transform="translate(' + cx + " " + cy + ") scale(" + s + ") translate(" + (-cx) + " " + (-cy) + ')">' + legs +
      '<ellipse cx="' + cx + '" cy="' + cy + '" rx="14" ry="13" fill="#111"/>' +
      '<circle cx="' + (cx - 5) + '" cy="' + (cy - 2) + '" r="5.5" fill="#fff"/><circle cx="' + (cx + 5) + '" cy="' + (cy - 2) + '" r="5.5" fill="#fff"/>' +
      '<circle cx="' + (cx - 4) + '" cy="' + (cy - .5) + '" r="2.6" fill="#111"/><circle cx="' + (cx + 4) + '" cy="' + (cy - .5) + '" r="2.6" fill="#111"/></g>';
  };

  ART.spider = function () { return svg("0 0 60 50", ART.spiderBody(30, 26, 1)); };

  ART.pumpkin = function (x, y, s) {
    return '<g transform="translate(' + x + " " + y + ") scale(" + s + ')">' +
      '<path d="M0 -40 C-1 -50 3 -56 10 -60" stroke="#3f6b22" stroke-width="6" fill="none" stroke-linecap="round"/>' +
      '<ellipse cx="-24" cy="0" rx="26" ry="32" fill="#e8700f"/><ellipse cx="24" cy="0" rx="26" ry="32" fill="#e8700f"/>' +
      '<ellipse cx="0" cy="-1" rx="27" ry="34" fill="#f58a1f"/>' +
      '<path d="M-18 -10 L-9 -20 L-3 -6Z M18 -10 L9 -20 L3 -6Z M-4 2 L0 -4 L4 2Z" fill="#ffd23f"/>' +
      '<path d="M-20 10 Q0 28 20 10 L14 13 L9 9 L4 15 L0 10 L-4 15 L-9 9 L-14 13Z" fill="#ffd23f"/></g>';
  };

  ART.witch = function () {
    return svg("0 0 140 120",
      '<circle cx="78" cy="52" r="42" fill="#ffcf6a" opacity=".92"/>' +
      '<path d="M6 92 L118 66" stroke="#4a2c14" stroke-width="4" stroke-linecap="round"/>' +
      '<path d="M112 62 L138 54 L136 82 L114 74Z" fill="#a8742c"/><path d="M114 66 L136 62 M114 70 L137 70 M114 73 L136 77" stroke="#7a5420" stroke-width="1.5"/>' +
      '<path d="M44 86 L54 54 L72 52 L82 82Z" fill="#141018"/>' +
      '<path d="M66 82 L58 98 L66 98" stroke="#141018" stroke-width="4" fill="none" stroke-linecap="round"/>' +
      '<circle cx="62" cy="46" r="8" fill="#141018"/>' +
      '<path d="M46 42 L80 42 L68 36 Q70 20 84 8 Q62 16 58 36Z" fill="#141018"/>' +
      '<path d="M56 50 Q40 52 30 64 Q44 58 56 58Z" fill="#141018"/>' +
      '<path d="M54 60 Q40 66 30 62" stroke="#141018" stroke-width="3" fill="none" stroke-linecap="round"/>');
  };

  ART.cat = function () {
    return svg("0 0 128 128",
      '<path d="M88 116 Q122 108 114 78 Q110 64 120 58" stroke="#141018" stroke-width="8" fill="none" stroke-linecap="round"/>' +
      '<ellipse cx="60" cy="94" rx="32" ry="30" fill="#141018"/>' +
      '<circle cx="60" cy="52" r="22" fill="#141018"/>' +
      '<path d="M42 40 L40 18 L56 32Z M78 40 L80 18 L64 32Z" fill="#141018"/>' +
      '<ellipse cx="51" cy="52" rx="5" ry="6" fill="#ffd23f"/><ellipse cx="69" cy="52" rx="5" ry="6" fill="#ffd23f"/>' +
      '<ellipse cx="51" cy="52" rx="1.4" ry="5" fill="#141018"/><ellipse cx="69" cy="52" rx="1.4" ry="5" fill="#141018"/>' +
      '<path d="M40 62 L22 58 M40 66 L22 68 M80 62 L98 58 M80 66 L98 68" stroke="#555" stroke-width="1"/>');
  };

  ART.sign = function (text, board, ink, extra) {
    var t = esc(String(text || "").replace(/ ([!?:;])/g, " $1")), fs = t.length > 16 ? 15 : t.length > 11 ? 18 : 21;
    var words = t.split(" "), l1 = t, l2 = "";
    if (t.length > 14 && words.length > 1) { var h = Math.ceil(words.length / 2); l1 = words.slice(0, h).join(" "); l2 = words.slice(h).join(" "); }
    return svg("0 0 160 150",
      '<rect x="74" y="60" width="10" height="90" fill="#5a3a1e"/>' +
      '<g transform="rotate(-6 80 50)"><rect x="12" y="18" width="136" height="64" rx="8" fill="' + board + '" stroke="#2a1a0c" stroke-width="3"/>' +
      '<text x="80" y="' + (l2 ? 46 : 57) + '" text-anchor="middle" font-family="\'Comic Sans MS\',\'Chalkboard SE\',cursive" font-weight="700" font-size="' + fs + '" fill="' + ink + '">' + l1 + "</text>" +
      (l2 ? '<text x="80" y="70" text-anchor="middle" font-family="\'Comic Sans MS\',\'Chalkboard SE\',cursive" font-weight="700" font-size="' + fs + '" fill="' + ink + '">' + l2 + "</text>" : "") +
      "</g>" + (extra || ""));
  };

  ART.graveyard = function () {
    return svg("0 0 420 90",
      '<path d="M0 90 L0 70 Q60 58 120 66 Q200 76 260 62 Q340 50 420 66 L420 90Z" fill="#141018"/>' +
      '<path d="M40 70 L40 44 Q40 32 52 32 Q64 32 64 44 L64 70Z" fill="#141018"/>' +
      '<path d="M130 68 L130 40 M120 50 L140 50" stroke="#141018" stroke-width="7"/>' +
      '<rect x="190" y="46" width="26" height="26" rx="4" fill="#141018"/>' +
      '<path d="M300 64 L300 30 M300 44 L284 30 M300 40 L318 24 M318 24 L326 26 M284 30 L278 24 M300 34 L310 20" stroke="#141018" stroke-width="4" stroke-linecap="round" fill="none"/>' +
      '<path d="M352 66 L352 52 M362 64 L362 50 M372 63 L372 49 M382 62 L382 48 M346 56 L388 52" stroke="#141018" stroke-width="3"/>' +
      '<path d="M352 52 L355 46 L358 52 M362 50 L365 44 L368 50 M372 49 L375 43 L378 49 M382 48 L385 42 L388 48" fill="#141018"/>');
  };

  ART.bat = function () {
    return svg("0 0 80 40", '<path d="M40 14 Q36 6 30 10 Q22 2 10 8 Q16 12 12 20 Q20 16 26 22 Q30 16 36 22 L40 28 L44 22 Q50 16 54 22 Q60 16 68 20 Q64 12 70 8 Q58 2 50 10 Q44 6 40 14Z" fill="#141018"/>' +
      '<path d="M37 12 L36 7 L39 11 M43 12 L44 7 L41 11" fill="#141018"/><circle cx="38" cy="15" r="1" fill="#ffd23f"/><circle cx="42" cy="15" r="1" fill="#ffd23f"/>');
  };

  ART.holly = function () {
    var leaf = function (x, y, r) { return '<path transform="translate(' + x + " " + y + ") rotate(" + r + ')" d="M0 0 Q8 -6 14 -2 Q18 -10 26 -6 Q30 -14 40 -10 Q34 -2 40 4 Q30 4 28 12 Q20 8 14 14 Q10 6 0 0Z" fill="#1f7a3a" stroke="#0f4d22" stroke-width="1"/>'; };
    return svg("0 0 130 130", leaf(4, 10, 20) + leaf(14, 4, 60) + leaf(2, 30, 5) + leaf(30, 2, 80) +
      '<circle cx="40" cy="36" r="7" fill="#d4142a"/><circle cx="52" cy="30" r="7" fill="#e3263a"/><circle cx="46" cy="46" r="7" fill="#c10f24"/>' +
      '<circle cx="38" cy="33" r="2" fill="#fff" opacity=".6"/><circle cx="50" cy="27" r="2" fill="#fff" opacity=".6"/>');
  };

  ART.blossom = function () {
    var fl = function (x, y, s) { var p = "", i; for (i = 0; i < 5; i++) p += '<ellipse cx="0" cy="-7" rx="5" ry="7" fill="#ffc2d9" transform="rotate(' + (i * 72) + ')"/>'; return '<g transform="translate(' + x + " " + y + ") scale(" + s + ')">' + p + '<circle r="3" fill="#ff7aa8"/></g>'; };
    return svg("0 0 130 130", '<path d="M0 6 Q40 14 70 40 Q86 56 100 60 M30 14 Q38 30 34 44 M60 32 Q72 26 84 30" stroke="#5a3a28" stroke-width="4" fill="none" stroke-linecap="round"/>' +
      fl(22, 12, 1) + fl(46, 22, .9) + fl(34, 44, 1.1) + fl(70, 40, 1) + fl(84, 30, .8) + fl(100, 60, 1));
  };

  ART.icicles = function () {
    var p = '<path d="M0 0 L130 0 L130 8 Q65 14 0 8Z" fill="#fff"/>', i;
    for (i = 0; i < 9; i++) p += '<path d="M' + (6 + i * 14) + " 6 L" + (12 + i * 14) + " " + (18 + (i * 37 % 26)) + " L" + (18 + i * 14) + ' 6Z" fill="#dff3ff" stroke="#bfe4fb" stroke-width=".8"/>';
    return svg("0 0 130 50", p);
  };

  ART.sun = function () {
    var r = "", i;
    for (i = 0; i < 12; i++) r += '<path d="M64 6 L70 22 L58 22Z" fill="#ffb300" transform="rotate(' + (i * 30) + ' 64 64)"/>';
    return svg("0 0 128 128", r + '<circle cx="64" cy="64" r="34" fill="#ffd23f"/><circle cx="54" cy="58" r="4" fill="#5a3a1e"/><circle cx="74" cy="58" r="4" fill="#5a3a1e"/><path d="M50 72 Q64 84 78 72" stroke="#5a3a1e" stroke-width="3.5" fill="none" stroke-linecap="round"/>');
  };

  ART.sleigh = function () {
    return svg("0 0 140 120", '<circle cx="80" cy="50" r="42" fill="#fff6d6" opacity=".9"/>' +
      '<g fill="#1d2a44"><path d="M64 74 L108 74 Q116 74 116 66 L116 58 L100 60 L96 70 L70 70 Z"/><path d="M60 80 L118 80 Q124 80 124 74" stroke="#1d2a44" stroke-width="3" fill="none"/>' +
      '<circle cx="104" cy="52" r="6"/><path d="M98 58 L110 58 L108 66 L100 66Z"/>' +
      '<path d="M18 66 Q22 58 30 60 L42 60 Q46 54 52 56 L50 62 L46 64 L44 72 L40 72 L40 66 L32 66 L30 72 L26 72 L26 66 Q20 68 18 66Z"/>' +
      '<path d="M46 56 L44 46 M44 50 L40 46 M48 54 L52 46 M50 50 L54 48" stroke="#1d2a44" stroke-width="2" fill="none"/>' +
      '<path d="M52 62 L64 70" stroke="#1d2a44" stroke-width="1.5"/></g>');
  };

  ART.snowman = function () {
    return svg("0 0 128 140", '<circle cx="64" cy="104" r="32" fill="#fff" stroke="#cfe3f3" stroke-width="2"/><circle cx="64" cy="56" r="22" fill="#fff" stroke="#cfe3f3" stroke-width="2"/>' +
      '<rect x="48" y="22" width="32" height="18" rx="2" fill="#141018"/><rect x="42" y="36" width="44" height="6" rx="2" fill="#141018"/><rect x="48" y="30" width="32" height="5" fill="#c10f24"/>' +
      '<circle cx="57" cy="54" r="2.6" fill="#141018"/><circle cx="71" cy="54" r="2.6" fill="#141018"/><path d="M64 60 L80 64 L64 64Z" fill="#f58a1f"/>' +
      '<path d="M44 74 Q64 82 84 74 L84 80 Q64 88 44 80Z" fill="#c10f24"/><path d="M78 78 L86 98 L78 98Z" fill="#c10f24"/>' +
      '<circle cx="64" cy="96" r="3" fill="#141018"/><circle cx="64" cy="108" r="3" fill="#141018"/>' +
      '<path d="M34 92 L12 76 M18 80 L14 72 M98 92 L118 78 M112 82 L118 74" stroke="#5a3a1e" stroke-width="3" stroke-linecap="round"/>');
  };

  ART.gifts = function (extra) {
    var box = function (x, y, w, h, c, r) { return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="3" fill="' + c + '"/><rect x="' + (x + w / 2 - 4) + '" y="' + y + '" width="8" height="' + h + '" fill="' + r + '"/><rect x="' + x + '" y="' + (y + h / 3) + '" width="' + w + '" height="7" fill="' + r + '"/>' +
      '<path d="M' + (x + w / 2) + " " + y + " q-14 -14 -16 -2 q2 6 16 2 q14 -14 16 -2 q-2 6 -16 2" + '" fill="' + r + '"/>'; };
    return svg("0 0 150 130", box(10, 64, 60, 60, "#c10f24", "#ffd23f") + box(74, 80, 56, 44, "#1f7a3a", "#fff") + box(42, 26, 48, 38, "#2b5fb8", "#ffd23f") + (extra || ""));
  };

  ART.snowHills = function () {
    var tree = function (x, s) { return '<g transform="translate(' + x + " 70) scale(" + s + ')"><path d="M0 -50 L16 -22 L8 -22 L20 -4 L-20 -4 L-8 -22 L-16 -22Z" fill="#1f5a34"/><path d="M0 -50 L6 -40 L-6 -40Z M-12 -10 L12 -10" stroke="#fff" stroke-width="3" fill="none"/></g>'; };
    return svg("0 0 420 90", tree(60, 1) + tree(90, .7) + tree(300, 1.1) + tree(338, .8) +
      '<path d="M0 90 L0 70 Q80 54 160 68 Q240 80 320 64 Q380 56 420 66 L420 90Z" fill="#fff"/><path d="M0 78 Q120 70 220 80 Q330 88 420 76" stroke="#d6ebf8" stroke-width="3" fill="none"/>');
  };

  ART.heart = function (c) { return svg("0 0 40 36", '<path d="M20 34 L4 18 Q-4 8 6 2 Q14 -2 20 8 Q26 -2 34 2 Q44 8 36 18Z" fill="' + (c || "#e3263a") + '"/><ellipse cx="11" cy="9" rx="4" ry="3" fill="#fff" opacity=".45"/>'); };

  ART.heartBalloons = function () {
    var h = function (x, y, s, c) { return '<g transform="translate(' + x + " " + y + ") scale(" + s + ')"><path d="M0 26 L-16 10 Q-24 0 -14 -6 Q-6 -10 0 0 Q6 -10 14 -6 Q24 0 16 10Z" fill="' + c + '"/><ellipse cx="-9" cy="-1" rx="4" ry="3" fill="#fff" opacity=".45"/></g>'; };
    return svg("0 0 128 140", '<path d="M40 60 Q50 100 62 132 M84 44 Q76 96 64 132 M62 74 Q60 104 64 132" stroke="#999" stroke-width="1.2" fill="none"/>' +
      h(40, 40, 1.3, "#e3263a") + h(86, 24, 1.2, "#ff6f9c") + h(62, 60, 1, "#c10f24") + '<path d="M56 128 L72 128 L68 136 L60 136Z" fill="#ff6f9c"/>');
  };

  ART.bunny = function () {
    return svg("0 0 128 140", '<ellipse cx="44" cy="30" rx="9" ry="28" fill="#fff" stroke="#e6dcd4" stroke-width="2" transform="rotate(-12 44 30)"/><ellipse cx="44" cy="30" rx="4" ry="20" fill="#ffc2d9" transform="rotate(-12 44 30)"/>' +
      '<ellipse cx="72" cy="28" rx="9" ry="28" fill="#fff" stroke="#e6dcd4" stroke-width="2" transform="rotate(10 72 28)"/><ellipse cx="72" cy="28" rx="4" ry="20" fill="#ffc2d9" transform="rotate(10 72 28)"/>' +
      '<ellipse cx="62" cy="106" rx="36" ry="30" fill="#fff" stroke="#e6dcd4" stroke-width="2"/><circle cx="98" cy="112" r="10" fill="#fff" stroke="#e6dcd4" stroke-width="2"/>' +
      '<circle cx="58" cy="66" r="24" fill="#fff" stroke="#e6dcd4" stroke-width="2"/><circle cx="50" cy="62" r="3" fill="#141018"/><circle cx="66" cy="62" r="3" fill="#141018"/>' +
      '<path d="M55 70 L61 70 L58 74Z" fill="#ff7aa8"/><path d="M58 74 Q54 80 50 78 M58 74 Q62 80 66 78" stroke="#141018" stroke-width="1.2" fill="none"/>');
  };

  ART.egg = function (c1, c2) { return '<ellipse cx="0" cy="0" rx="12" ry="16" fill="' + c1 + '"/><path d="M-12 -2 Q-6 -8 0 -2 Q6 4 12 -2 L12 3 Q6 9 0 3 Q-6 -3 -12 3Z" fill="' + c2 + '"/>'; };

  ART.basket = function () {
    var e = function (x, y, a, b, r) { return '<g transform="translate(' + x + " " + y + ") rotate(" + r + ')">' + ART.egg(a, b) + "</g>"; };
    return svg("0 0 150 130", '<path d="M30 70 Q75 0 120 70" stroke="#8a5a2b" stroke-width="6" fill="none"/>' +
      e(52, 62, "#ffd23f", "#ff7aa8", -14) + e(76, 56, "#8fd0ff", "#fff", 4) + e(100, 62, "#b6e3a1", "#ff9f43", 16) +
      '<path d="M22 70 L128 70 L116 120 L34 120Z" fill="#c98a4b"/><path d="M28 86 L122 86 M32 102 L118 102 M50 70 L54 120 M75 70 L75 120 M100 70 L96 120" stroke="#8a5a2b" stroke-width="2.5"/>');
  };

  ART.grass = function (flowers) {
    var g = '<path d="M0 90 L0 72 Q100 62 210 72 Q320 80 420 70 L420 90Z" fill="#4caf50"/>', i, x;
    for (i = 0; i < 40; i++) { x = i * 10.5; g += '<path d="M' + x + " 76 Q" + (x + 3) + " " + (60 - (i * 7) % 10) + " " + (x + 6) + ' 76" fill="#3d9142"/>'; }
    if (flowers) for (i = 0; i < 9; i++) { x = 20 + i * 46; var c = ["#ff7aa8", "#ffd23f", "#fff", "#b388ff"][i % 4]; g += '<path d="M' + x + ' 76 L' + x + ' 56" stroke="#2e7d32" stroke-width="2"/><g transform="translate(' + x + ' 54)"><circle cx="0" cy="-5" r="4" fill="' + c + '"/><circle cx="5" cy="0" r="4" fill="' + c + '"/><circle cx="0" cy="5" r="4" fill="' + c + '"/><circle cx="-5" cy="0" r="4" fill="' + c + '"/><circle r="3" fill="#ffb300"/></g>'; }
    return svg("0 0 420 90", g);
  };

  ART.beach = function () {
    var w = '<path d="M0 90 L0 74 Q30 66 60 74 T120 74 T180 74 T240 74 T300 74 T360 74 T420 74 L420 90Z" fill="#2fa4d9"/><path d="M0 82 Q30 76 60 82 T120 82 T180 82 T240 82 T300 82 T360 82 T420 82" stroke="#bfe9ff" stroke-width="2" fill="none"/>';
    return svg("0 0 420 90", '<path d="M300 70 Q296 40 312 14" stroke="#7a5420" stroke-width="5" fill="none"/>' +
      '<path d="M312 14 Q290 6 276 18 Q296 14 312 14 Q326 0 344 6 Q326 10 312 14 Q336 18 340 34 Q324 22 312 14 Q300 30 290 34 Q298 20 312 14Z" fill="#2e7d32"/>' + w);
  };

  ART.leafShape = "M0 -14 Q10 -10 12 0 Q10 10 0 14 Q-10 10 -12 0 Q-10 -10 0 -14Z M0 -14 L0 14";
  ART.leaf = function (c) { return svg("-16 -16 32 32", '<path d="M0 -14 Q11 -9 12 0 Q10 11 0 15 Q-10 11 -12 0 Q-11 -9 0 -14Z" fill="' + c + '"/><path d="M0 -12 L0 14 M0 0 L6 -5 M0 5 L-6 0" stroke="#7a3b12" stroke-width="1" fill="none"/>'); };

  ART.leafPile = function () {
    var g = '<path d="M0 90 L0 76 Q100 66 210 76 Q320 84 420 74 L420 90Z" fill="#8a4b1d"/>', i, cs = ["#e0812a", "#c0461b", "#f2b134", "#9b5a1a"];
    for (i = 0; i < 46; i++) g += '<ellipse cx="' + (i * 9.3) + '" cy="' + (74 + (i * 13) % 8) + '" rx="7" ry="4" fill="' + cs[i % 4] + '" transform="rotate(' + ((i * 47) % 70 - 35) + " " + (i * 9.3) + " " + (74 + (i * 13) % 8) + ')"/>';
    var mush = function (x, s) { return '<g transform="translate(' + x + " 72) scale(" + s + ')"><rect x="-4" y="-14" width="8" height="14" rx="3" fill="#f3e6cf"/><path d="M-16 -12 Q0 -32 16 -12Z" fill="#c10f24"/><circle cx="-6" cy="-19" r="2.2" fill="#fff"/><circle cx="5" cy="-22" r="2" fill="#fff"/></g>'; };
    return svg("0 0 420 90", g + mush(70, 1.2) + mush(92, .8) + mush(330, 1));
  };

  ART.hedgehog = function () {
    var sp = "", i;
    for (i = 0; i < 16; i++) { var a = Math.PI * (1.05 + i * .06); sp += '<path d="M' + (64 + 36 * Math.cos(a)).toFixed(1) + " " + (92 + 32 * Math.sin(a)).toFixed(1) + " L" + (64 + 52 * Math.cos(a + .03)).toFixed(1) + " " + (92 + 46 * Math.sin(a + .03)).toFixed(1) + " L" + (64 + 36 * Math.cos(a + .08)).toFixed(1) + " " + (92 + 32 * Math.sin(a + .08)).toFixed(1) + 'Z" fill="#5a3a1e"/>'; }
    return svg("0 0 128 128", sp + '<ellipse cx="64" cy="94" rx="44" ry="28" fill="#7a5130"/><path d="M96 86 Q122 92 120 102 Q112 112 92 108Z" fill="#e6c9a3"/>' +
      '<circle cx="119" cy="100" r="4" fill="#141018"/><circle cx="104" cy="94" r="3" fill="#141018"/><path d="M40 118 L40 124 M60 120 L60 126 M84 118 L84 124" stroke="#5a3a1e" stroke-width="4" stroke-linecap="round"/>' +
      '<path d="M30 70 Q24 60 32 56 Q34 64 30 70Z" fill="#e0812a"/>');
  };

  ART.champagne = function () {
    var glass = function (x, r) { return '<g transform="translate(' + x + " 30) rotate(" + r + ')"><path d="M-12 0 L12 0 L8 40 Q0 46 -8 40Z" fill="#ffe08a" stroke="#c9a227" stroke-width="2"/><path d="M0 44 L0 76 M-12 78 L12 78" stroke="#c9a227" stroke-width="3"/><circle cx="-3" cy="20" r="2" fill="#fff"/><circle cx="3" cy="30" r="1.6" fill="#fff"/></g>'; };
    return svg("0 0 128 128", glass(46, -12) + glass(82, 12) + '<path d="M64 20 L60 6 M64 20 L72 4 M64 20 L52 10" stroke="#ffd23f" stroke-width="2.5" stroke-linecap="round"/>');
  };

  ART.tag = function (text, bg, fg) {
    return svg("0 0 70 44", '<path d="M14 2 L66 2 Q68 2 68 4 L68 40 Q68 42 66 42 L14 42 L2 22Z" fill="' + bg + '" stroke="#111" stroke-width="1.5"/><circle cx="14" cy="22" r="4" fill="#fff"/>' +
      '<text x="42" y="28" text-anchor="middle" font-family="Arial,sans-serif" font-weight="900" font-size="16" fill="' + fg + '">' + esc(text) + "</text>");
  };

  ART.bauble = function (c) { return svg("0 0 40 48", '<rect x="15" y="0" width="10" height="8" rx="2" fill="#c9a227"/><circle cx="20" cy="28" r="18" fill="' + c + '"/><path d="M4 26 Q20 34 36 26" stroke="#fff" stroke-opacity=".6" stroke-width="2" fill="none"/><ellipse cx="13" cy="20" rx="4" ry="6" fill="#fff" opacity=".45"/>'); };
  ART.star = function (c) { return svg("-20 -20 40 40", '<path d="M0 -18 L5 -6 L18 -6 L8 2 L12 15 L0 7 L-12 15 L-8 2 L-18 -6 L-5 -6Z" fill="' + (c || "#ffd23f") + '" stroke="#c9a227" stroke-width="1"/>'); };
  ART.flake = function () { var b = "", i; for (i = 0; i < 6; i++) b += '<g transform="rotate(' + (i * 60) + ')"><path d="M0 0 L0 -16 M0 -10 L-5 -14 M0 -10 L5 -14" stroke="#fff" stroke-width="2" stroke-linecap="round"/></g>'; return svg("-20 -20 40 40", b); };
  ART.butterfly = function () { return svg("-24 -20 48 40", '<path d="M0 0 Q-20 -24 -22 -4 Q-20 6 0 2Z" fill="#ff9f43"/><path d="M0 0 Q20 -24 22 -4 Q20 6 0 2Z" fill="#ff9f43"/><path d="M0 2 Q-16 18 -12 6Z M0 2 Q16 18 12 6Z" fill="#ffd23f"/><ellipse rx="2" ry="9" fill="#3b2412"/>'); };
  ART.ghost = function () { return svg("0 0 40 48", '<path d="M4 46 L4 20 Q4 2 20 2 Q36 2 36 20 L36 46 L30 40 L24 46 L18 40 L12 46 L8 42Z" fill="#fff" opacity=".92"/><ellipse cx="14" cy="20" rx="3" ry="4.5" fill="#141018"/><ellipse cx="26" cy="20" rx="3" ry="4.5" fill="#141018"/><ellipse cx="20" cy="30" rx="3" ry="4" fill="#141018"/>'); };

  // --------------------------------------------------------------------------
  // Ambiances (presets)
  // --------------------------------------------------------------------------
  var PRESETS = {
    halloween: {
      fall: "bats", garland: ["#ff8200", "#d13f00", "#ff4d00"], corners: function () { return ART.cobweb("#ffffff"); }, cornersFlip: true,
      hanging: "spider", topLeft: ART.witch, bottomLeft: ART.cat,
      bottomRight: function (t) { return ART.sign(t || "Trick or Treat!", "#6b4423", "#ffd23f", ART.pumpkin(30, 112, .42) + ART.pumpkin(134, 116, .36)); },
      sign: "Trick or Treat!", footer: ART.graveyard, ribbon: null
    },
    noel: {
      fall: "snow", garland: ["#e3263a", "#1f9d55", "#ffd23f", "#2b7de9"], corners: ART.holly, hanging: "bauble", topLeft: ART.sleigh, bottomLeft: ART.snowman,
      bottomRight: function () { return ART.gifts(); }, sign: "Joyeux Noël !", footer: ART.snowHills, footerH: 80, ribbon: null
    },
    hiver: {
      fall: "snow", garland: null, corners: ART.icicles, cornersStrip: true, hanging: "flake", topLeft: null, bottomLeft: ART.snowman,
      bottomRight: null, sign: "", footer: ART.snowHills, footerH: 80, ribbon: null
    },
    black_friday: {
      fall: "percent", garland: ["#ffd23f", "#ffffff", "#ffd23f"], corners: null, hanging: "tag_bf", topLeft: null, bottomLeft: null,
      bottomRight: function (t) { return ART.sign(t || "BLACK FRIDAY", "#111", "#ffd23f"); }, sign: "BLACK FRIDAY", footer: null, ribbon: "BLACK FRIDAY"
    },
    soldes: {
      fall: "confetti", garland: ["#e3263a", "#ffffff", "#ffd23f"], corners: null, hanging: "tag_soldes", topLeft: null, bottomLeft: null,
      bottomRight: function (t) { return ART.sign(t || "SOLDES", "#e3263a", "#ffffff"); }, sign: "SOLDES", footer: null, ribbon: "SOLDES", ribbonBg: "#e3263a", ribbonFg: "#fff"
    },
    saint_valentin: {
      fall: "hearts", garland: ["#ff6f9c", "#e3263a", "#ffc2d9"], corners: null, hanging: "heart", topLeft: null, bottomLeft: ART.heartBalloons,
      bottomRight: function (t) { return ART.sign(t || "Joyeuse Saint-Valentin", "#ffd6e5", "#c10f24"); }, sign: "Joyeuse Saint-Valentin", footer: null, ribbon: null
    },
    paques: {
      fall: "eggs", garland: ["#ffd23f", "#8fd0ff", "#ff9fc4", "#b6e3a1"], corners: ART.blossom, hanging: "egg", topLeft: null, bottomLeft: ART.bunny,
      bottomRight: function () { return ART.basket(); }, sign: "Joyeuses Pâques", footer: function () { return ART.grass(true); }, footerH: 90, ribbon: null
    },
    printemps: {
      fall: "petals", garland: null, corners: ART.blossom, hanging: "butterfly", topLeft: null, bottomLeft: null,
      bottomRight: null, sign: "", footer: function () { return ART.grass(true); }, footerH: 90, ribbon: null
    },
    ete: {
      fall: "sparkles", garland: ["#ff9f43", "#2fa4d9", "#ffd23f", "#4caf50"], corners: null, hanging: null, topLeft: ART.sun, bottomLeft: null,
      bottomRight: function (t) { return ART.sign(t || "Bel été !", "#ffe08a", "#c0461b"); }, sign: "Bel été !", footer: ART.beach, footerH: 90, ribbon: null
    },
    automne: {
      fall: "leaves", garland: ["#e0812a", "#c0461b", "#f2b134"], corners: null, hanging: "leaf", topLeft: null, bottomLeft: ART.hedgehog,
      bottomRight: null, sign: "", footer: ART.leafPile, footerH: 90, ribbon: null
    },
    nouvel_an: {
      fall: "confetti", garland: ["#ffd23f", "#ffffff", "#c9a227"], corners: null, hanging: "star", topLeft: null, bottomLeft: ART.champagne,
      bottomRight: function (t) { return ART.sign(t || "Bonne année !", "#141018", "#ffd23f"); }, sign: "Bonne année !", footer: null, ribbon: null, fireworks: true
    }
  };

  // --------------------------------------------------------------------------
  // Résolution de la config (manuel / calendrier / forçage URL)
  // --------------------------------------------------------------------------
  function fromCalendar(txt) {
    var d = new Date(), today = (d.getMonth() + 1) * 100 + d.getDate();
    var lines = String(txt || "").split(/\r?\n/), i, m, a, b;
    for (i = 0; i < lines.length; i++) {
      m = lines[i].trim().match(/^(\d{1,2})-(\d{1,2})\s*(?:\.\.|>|→|au)\s*(\d{1,2})-(\d{1,2})\s*=\s*([a-z_]+)/i);
      if (!m) continue;
      a = +m[1] * 100 + +m[2]; b = +m[3] * 100 + +m[4];
      if ((a <= b && today >= a && today <= b) || (a > b && (today >= a || today <= b))) return m[5].toLowerCase();
    }
    return null;
  }

  function pageAllowed() {
    var mode = C.pages || "all", pt = C.page_type || "", path = location.pathname.replace(/\/$/, "") || "/";
    if (/^\/(checkout|checkouts|cart)(\/|$)/.test(path) && C.exclude_cart !== false) return false;
    if (mode === "home") return pt === "index" || path === "/";
    if (mode === "home_collections_products") return /^(index|collection|product|list-collections)$/.test(pt) || path === "/";
    if (mode === "custom") {
      return String(C.pages_custom || "").split(/[\n,]+/).some(function (p) {
        p = p.trim().replace(/^https?:\/\/[^/]+/, "").replace(/\/$/, "") || "/";
        if (!p) return false;
        return p.slice(-1) === "*" ? path.indexOf(p.slice(0, -1)) === 0 : path === p;
      });
    }
    return true;
  }

  var presetKey;
  if (Q === "off") return;
  if (Q && PRESETS[Q]) presetKey = Q;
  else {
    if (!C.enabled) return;
    presetKey = C.mode === "auto" ? fromCalendar(C.calendar) : C.preset;
    if (!presetKey || presetKey === "none" || !PRESETS[presetKey]) return;
    if (!pageAllowed()) return;
  }
  var isMobile = window.matchMedia("(max-width: 749px)").matches;
  if (isMobile && C.mobile === false && !Q) return;
  var reduce = C.reduced_motion !== false && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var P = PRESETS[presetKey];
  var F = C.fall || {}, D = C.deco || {};
  var on = function (k) { return Q ? true : D[k] !== false; };
  var scale = num(C.scale, 100) / 100 * (isMobile ? .7 : 1);
  var Z = num(C.z_index, 2147482000);
  var dismissible = C.dismiss !== false;

  // --------------------------------------------------------------------------
  // CSS
  // --------------------------------------------------------------------------
  var css = [
    ".cbs-fixed{position:fixed;pointer-events:none;z-index:" + Z + "}",
    ".cbs-fixed.cbs-click,.cbs-abs.cbs-click{pointer-events:auto;cursor:pointer}",
    ".cbs-abs{position:absolute;pointer-events:none;z-index:" + Z + "}",
    ".cbs-top{position:absolute;top:0;left:0;width:100%;height:0;overflow:visible;z-index:" + Z + ";pointer-events:none}",
    ".cbs-img{display:block;background:center/contain no-repeat}",
    ".cbs-rope{position:absolute;top:-6px;left:0;width:100%;white-space:nowrap;overflow:hidden;margin:0;padding:0;height:46px;pointer-events:none}",
    ".cbs-rope i{position:relative;display:inline-block;width:12px;height:26px;margin:16px 19px 0;border-radius:50%;animation:cbs-flash 1.4s infinite both}",
    ".cbs-rope i:before{content:'';position:absolute;top:-5px;left:1px;width:10px;height:9px;border-radius:3px;background:#222}",
    ".cbs-rope i:after{content:'';position:absolute;top:-15px;left:9px;width:52px;height:18px;border-bottom:2px solid #222;border-radius:50%}",
    ".cbs-rope i:last-child:after{content:none}",
    "@keyframes cbs-flash{0%,100%{opacity:1;filter:brightness(1.15)}50%{opacity:.35;filter:brightness(.6);box-shadow:none}}",
    ".cbs-hang{position:absolute;top:0;transform-origin:50% 0}",
    ".cbs-hang:before{content:'';position:absolute;left:50%;bottom:100%;width:1px;height:600px;background:rgba(170,170,170,.9)}",
    ".cbs-hang.cbs-y{animation:cbs-yo 5s ease-in-out infinite}",
    ".cbs-hang.cbs-sw{animation:cbs-sway 3.4s ease-in-out infinite}",
    "@keyframes cbs-yo{0%,100%{transform:translateY(0)}50%{transform:translateY(-70px)}}",
    "@keyframes cbs-sway{0%,100%{transform:rotate(-6deg)}50%{transform:rotate(6deg)}}",
    ".cbs-float{animation:cbs-float 4s ease-in-out infinite}",
    "@keyframes cbs-float{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}",
    ".cbs-ribbon-box{position:fixed;top:0;right:0;width:170px;height:170px;overflow:hidden;z-index:" + Z + ";pointer-events:none}",
    ".cbs-ribbon{position:absolute;top:44px;right:-56px;width:240px;transform:rotate(45deg);text-align:center;font:900 14px/32px Arial,sans-serif;letter-spacing:1px;color:var(--cbs-rfg,#ffd23f);background:var(--cbs-rbg,#111);box-shadow:0 3px 10px rgba(0,0,0,.35);white-space:nowrap}",
    ".cbs-canvas{position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:" + (Z - 1) + "}",
    "@media (max-width:999px){.cbs-hide-md{display:none!important}}",
    reduce ? ".cbs-rope i,.cbs-hang,.cbs-float{animation:none!important}" : ""
  ].join("");
  var st = document.createElement("style"); st.id = "cbs-style"; st.textContent = css;
  document.head.appendChild(st);

  // --------------------------------------------------------------------------
  // Décorations
  // --------------------------------------------------------------------------
  var nodes = [];
  function el(tag, cls, style, html) {
    var e = document.createElement(tag); e.className = cls; e.setAttribute("aria-hidden", "true");
    if (style) e.style.cssText = style; if (html) e.innerHTML = html;
    if (dismissible && /cbs-click/.test(cls)) e.addEventListener("click", function (ev) { ev.stopPropagation(); e.style.display = "none"; });
    nodes.push(e); return e;
  }
  function img(svgStr, cls, style) { return el("span", "cbs-img " + cls, "background-image:url(\"" + svgUri(svgStr) + "\");" + style); }

  function build() {
    var top = el("div", "cbs-top"), s = scale, w = document.documentElement.clientWidth || window.innerWidth;
    document.body.appendChild(top);

    // Guirlande lumineuse
    if (P.garland && on("garland")) {
      var rope = el("div", "cbs-rope"), n = Math.ceil(w / 50) + 1, h = "", i, c;
      for (i = 0; i < n; i++) {
        c = P.garland[i % P.garland.length];
        h += '<i style="background:' + c + ";box-shadow:0 4px 22px 3px " + c + "99;animation-duration:" + (1 + (i * 37 % 10) / 10).toFixed(1) + "s;animation-delay:" + ((i * 13 % 10) / 10).toFixed(1) + 's"></i>';
      }
      rope.innerHTML = h; top.appendChild(rope);
    }

    // Coins (toiles, houx, glaçons, fleurs)
    if (P.corners && on("corners")) {
      var cs = P.corners(), sz = Math.round((isMobile ? 120 : 170) * s);
      if (P.cornersStrip) {
        document.body.appendChild(img(cs, "cbs-fixed", "top:0;left:0;width:100%;height:" + Math.round(40 * s) + "px;background-size:auto 100%;background-repeat:repeat-x;background-position:0 0"));
      } else {
        document.body.appendChild(img(cs, "cbs-fixed", "top:0;left:0;width:" + sz + "px;height:" + sz + "px"));
        document.body.appendChild(img(cs, "cbs-fixed", "top:0;right:0;width:" + sz + "px;height:" + sz + "px;transform:scaleX(-1)"));
      }
    }

    // Éléments suspendus
    if (P.hanging && on("hanging")) {
      var spots = [[7, 172, 0], [25, 184, 1], [45, 120, 0], [65, 210, 1], [80, 96, 1], [95, 230, 0]], j, sp, art, hw, hh, cls;
      for (j = 0; j < spots.length; j++) {
        sp = spots[j]; hw = 52; hh = 46;
        switch (P.hanging) {
          case "spider": art = ART.spider(); hw = 78; hh = 64; break;
          case "bauble": art = ART.bauble(P.garland[j % P.garland.length]); hw = 40; hh = 48; break;
          case "flake": art = ART.flake(); hw = 40; hh = 40; break;
          case "heart": art = ART.heart(["#e3263a", "#ff6f9c", "#c10f24"][j % 3]); hw = 44; hh = 40; break;
          case "egg": art = svg("-14 -18 28 36", ART.egg(["#ffd23f", "#8fd0ff", "#ff9fc4", "#b6e3a1"][j % 4], "#fff")); hw = 32; hh = 42; break;
          case "butterfly": art = ART.butterfly(); hw = 48; hh = 40; break;
          case "leaf": art = ART.leaf(["#e0812a", "#c0461b", "#f2b134"][j % 3]); hw = 40; hh = 40; break;
          case "star": art = ART.star(); hw = 40; hh = 40; break;
          case "tag_bf": art = ART.tag("-" + [20, 30, 50, 40, 25, 60][j] + "%", "#111", "#ffd23f"); hw = 70; hh = 44; break;
          case "tag_soldes": art = ART.tag("-" + [20, 30, 50, 40, 25, 60][j] + "%", "#e3263a", "#fff"); hw = 70; hh = 44; break;
        }
        cls = "cbs-hang " + (P.hanging === "spider" ? "cbs-y" : "cbs-sw") + (j === 1 || j === 3 || j === 4 ? " cbs-hide-md" : "");
        var hx = Math.max(4, Math.min(sp[0] / 100 * w - hw * s / 2, w - hw * s - 6));
        top.appendChild(img(art, cls, "left:" + Math.round(hx) + "px;top:" + Math.round((sp[1] - (P.hanging === "spider" ? 0 : 60)) * s) + "px;width:" + Math.round(hw * s) + "px;height:" + Math.round(hh * s) + "px;animation-delay:-" + (j * .8).toFixed(1) + "s;animation-duration:" + (4 + j * .4).toFixed(1) + "s"));
      }
    }

    // Personnage haut-gauche
    if (P.topLeft && on("top_left")) document.body.appendChild(img(P.topLeft(), "cbs-fixed cbs-float", "top:" + (P.garland && on("garland") ? 30 : 4) + "px;left:4px;width:" + Math.round(140 * s) + "px;height:" + Math.round(120 * s) + "px"));
    // Personnage bas-gauche
    if (P.bottomLeft && on("bottom_left")) document.body.appendChild(img(P.bottomLeft(), "cbs-fixed cbs-click", "bottom:" + Math.round((P.footer && on("footer") ? 18 : 0) * s) + "px;left:6px;width:" + Math.round(128 * s) + "px;height:" + Math.round(128 * s) + "px"));
    // Panneau / objet bas-droite (évite la bulle de chat : décalé vers la gauche)
    if (P.bottomRight && on("bottom_right")) {
      var off = num(C.bottom_right_offset, 90);
      document.body.appendChild(img(P.bottomRight(C.sign_text), "cbs-fixed cbs-click", "bottom:" + Math.round((P.footer && on("footer") ? 14 : 0) * s) + "px;right:" + off + "px;width:" + Math.round(150 * s) + "px;height:" + Math.round(140 * s) + "px"));
    }
    // Pied de page (silhouette)
    if (P.footer && on("footer")) document.body.appendChild(img(P.footer(), "cbs-fixed", "left:0;right:0;bottom:0;height:" + Math.round((P.footerH || 64) * s) + "px;background-size:auto 100%;background-repeat:repeat-x;background-position:0 100%"));
    // Bandeau d'angle
    if (P.ribbon && on("ribbon")) {
      var rb = el("div", "cbs-ribbon-box", "--cbs-rbg:" + (P.ribbonBg || "#111") + ";--cbs-rfg:" + (P.ribbonFg || "#ffd23f"));
      rb.innerHTML = '<div class="cbs-ribbon">' + esc(C.ribbon_text || P.ribbon) + "</div>"; document.body.appendChild(rb);
    }
  }

  // --------------------------------------------------------------------------
  // Effets de chute (canvas, pseudo-3D : profondeur + rotation)
  // --------------------------------------------------------------------------
  var FALL_EMOJI = { bats: null, pumpkins: ["🎃"], ghosts: null, candy: ["🍬", "🍭", "🍫"], gifts: ["🎁"], snowmen: ["⛄"], money: ["💸", "💶"], stars: null, flowers: ["🌸", "🌼", "🌷"], fruits: ["🍉", "🍓", "🍍"], balloons: ["🎈"], chicks: ["🐣", "🐥"], bugs: ["🐛", "🪲", "🦗"] };
  var SPRITES = {};
  function sprite(key, svgStr, size) {
    if (SPRITES[key]) return SPRITES[key];
    var im = new Image(); im.src = svgUri(svgStr); SPRITES[key] = im; return im;
  }

  function startFall(type) {
    if (reduce || type === "none") return;
    var cv = el("canvas", "cbs-canvas"); document.body.appendChild(cv);
    var ctx = cv.getContext("2d"), dpr = Math.min(window.devicePixelRatio || 1, 2), W, H;
    function size() { W = window.innerWidth; H = window.innerHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    size(); window.addEventListener("resize", size);

    var count = Math.round(num(F.count, 40) * (isMobile ? .6 : 1));
    var speed = num(F.speed, 5) / 5, sz = num(F.size, 100) / 100, alpha = num(F.opacity, 90) / 100;
    var color = F.color || "#ffffff", wind = F.wind !== false, depth = F.depth !== false;
    var dur = num(F.duration, 0) * 1000, t0 = performance.now();
    var custom = String(F.custom || "").trim();
    var emojis = custom ? Array.from ? Array.from(custom.replace(/\s+/g, "")) : custom.split("") : FALL_EMOJI[type];
    var confC = ["#e3263a", "#ffd23f", "#2b7de9", "#1f9d55", "#ff6f9c", "#ff9f43", "#ffffff"];
    var parts = [], i, fog = type === "fog";

    function mk(initial) {
      var z = depth ? rnd(.45, 1.25) : 1;
      return {
        x: rnd(0, W), y: initial ? rnd(-H, H) : rnd(-60, -20), z: z,
        vy: (fog ? rnd(-.05, .05) : rnd(.6, 1.4)) * speed * z, vx: fog ? rnd(.15, .4) * speed : 0,
        sw: rnd(.4, 1.6), ph: rnd(0, 6.28), r: rnd(0, 6.28), vr: rnd(-.04, .04), fl: rnd(0, 6.28), vf: rnd(.02, .07),
        c: pick(confC), e: emojis ? pick(emojis) : null, k: (Math.random() * 3) | 0,
        s: (fog ? rnd(140, 280) : rnd(8, 14)) * sz * z
      };
    }
    if (fog) { count = Math.min(count, 14); }
    if (type === "none_fw" || type === "fireworks") count = 0;
    for (i = 0; i < count; i++) parts.push(mk(true));

    var leafCols = ["#e0812a", "#c0461b", "#f2b134", "#9b5a1a"], petal = ["#ffc2d9", "#ffd6e5", "#fff0f5"];
    var heartP = typeof Path2D !== "undefined" ? new Path2D("M0 7 L-7 0 Q-11 -5 -6 -8 Q-2 -10 0 -5 Q2 -10 6 -8 Q11 -5 7 0Z") : null;
    var leafP = typeof Path2D !== "undefined" ? new Path2D("M0 -9 Q7 -6 8 0 Q6 7 0 9 Q-6 7 -8 0 Q-7 -6 0 -9Z") : null;
    var starP = typeof Path2D !== "undefined" ? new Path2D("M0 -9 L2.6 -3 L9 -3 L4 1 L6 8 L0 4 L-6 8 L-4 1 L-9 -3 L-2.6 -3Z") : null;
    var batIm = sprite("bat", ART.bat()), ghostIm = sprite("ghost", ART.ghost()), flakeIm = sprite("flake", ART.flake());

    var fw = [];
    function firework() {
      var x = rnd(W * .15, W * .85), y = rnd(H * .1, H * .45), c = pick(confC), k;
      for (k = 0; k < 42; k++) { var a = k / 42 * 6.283, v = rnd(1.5, 3.6); fw.push({ x: x, y: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, l: 1, c: c }); }
    }

    function draw(p) {
      var flip = depth ? Math.cos(p.fl) : 1;
      ctx.save(); ctx.translate(p.x, p.y); ctx.globalAlpha = alpha * (depth ? Math.min(1, .45 + p.z * .5) : 1);
      switch (type) {
        case "snow":
          ctx.fillStyle = color; ctx.shadowColor = color; ctx.shadowBlur = 4 * p.z;
          if (p.k === 0) { ctx.rotate(p.r); ctx.drawImage(flakeIm, -p.s, -p.s, p.s * 2, p.s * 2); }
          else { ctx.beginPath(); ctx.arc(0, 0, p.s * .32, 0, 6.283); ctx.fill(); }
          break;
        case "confetti":
          ctx.rotate(p.r); ctx.scale(flip, 1); ctx.fillStyle = p.c; ctx.fillRect(-p.s * .35, -p.s * .6, p.s * .7, p.s * 1.2); break;
        case "hearts":
          ctx.rotate(p.r * .3); ctx.scale(flip * p.s / 9, p.s / 9); ctx.fillStyle = ["#e3263a", "#ff6f9c", "#c10f24"][p.k]; if (heartP) ctx.fill(heartP); break;
        case "leaves":
          ctx.rotate(p.r); ctx.scale(flip * p.s / 9, p.s / 9); ctx.fillStyle = leafCols[p.k]; if (leafP) { ctx.fill(leafP); ctx.strokeStyle = "rgba(90,40,10,.6)"; ctx.lineWidth = .8; ctx.beginPath(); ctx.moveTo(0, -8); ctx.lineTo(0, 8); ctx.stroke(); } break;
        case "petals":
          ctx.rotate(p.r); ctx.scale(flip, 1); ctx.fillStyle = petal[p.k]; ctx.beginPath(); ctx.ellipse(0, 0, p.s * .55, p.s * .32, 0, 0, 6.283); ctx.fill(); break;
        case "stars": case "sparkles":
          ctx.rotate(p.r); ctx.scale(p.s / 9, p.s / 9); ctx.fillStyle = type === "stars" ? "#ffd23f" : color; ctx.shadowColor = "#fff6c0"; ctx.shadowBlur = 8;
          if (type === "sparkles") ctx.globalAlpha *= .5 + .5 * Math.sin(p.fl * 2);
          if (starP) ctx.fill(starP); break;
        case "eggs":
          ctx.rotate(p.r * .5); ctx.scale(flip * p.s / 12, p.s / 12);
          ctx.fillStyle = ["#ffd23f", "#8fd0ff", "#ff9fc4", "#b6e3a1"][p.k]; ctx.beginPath(); ctx.ellipse(0, 0, 8, 11, 0, 0, 6.283); ctx.fill();
          ctx.strokeStyle = "#fff"; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(-8, 0); ctx.quadraticCurveTo(-4, -4, 0, 0); ctx.quadraticCurveTo(4, 4, 8, 0); ctx.stroke(); break;
        case "percent":
          ctx.rotate(p.r * .4); ctx.scale(flip, 1); ctx.font = "900 " + Math.round(p.s * 1.6) + "px Arial,sans-serif"; ctx.textAlign = "center"; ctx.textBaseline = "middle";
          ctx.fillStyle = p.k === 0 ? "#ffd23f" : p.k === 1 ? "#111" : "#e3263a"; ctx.strokeStyle = p.k === 1 ? "#ffd23f" : "rgba(0,0,0,.4)"; ctx.lineWidth = 1.2;
          ctx.strokeText("%", 0, 0); ctx.fillText("%", 0, 0); break;
        case "bats":
          ctx.rotate(Math.sin(p.ph) * .25); ctx.scale(1, .7 + .3 * Math.abs(Math.sin(p.fl * 3))); ctx.drawImage(batIm, -p.s * 1.8, -p.s * .9, p.s * 3.6, p.s * 1.8); break;
        case "ghosts":
          ctx.drawImage(ghostIm, -p.s * 1.1, -p.s * 1.3, p.s * 2.2, p.s * 2.6); break;
        case "bubbles":
          ctx.strokeStyle = "rgba(255,255,255,.85)"; ctx.lineWidth = 1.4; ctx.fillStyle = "rgba(180,225,255,.18)";
          ctx.beginPath(); ctx.arc(0, 0, p.s * .9, 0, 6.283); ctx.fill(); ctx.stroke();
          ctx.fillStyle = "rgba(255,255,255,.7)"; ctx.beginPath(); ctx.arc(-p.s * .3, -p.s * .3, p.s * .18, 0, 6.283); ctx.fill(); break;
        case "fog":
          var g = ctx.createRadialGradient(0, 0, 0, 0, 0, p.s); g.addColorStop(0, "rgba(220,215,235,.35)"); g.addColorStop(1, "rgba(220,215,235,0)");
          ctx.fillStyle = g; ctx.beginPath(); ctx.arc(0, 0, p.s, 0, 6.283); ctx.fill(); break;
        default:
          if (p.e) { ctx.rotate(p.r * .5); ctx.scale(flip, 1); ctx.font = Math.round(p.s * 2) + "px serif"; ctx.textAlign = "center"; ctx.textBaseline = "middle"; ctx.fillText(p.e, 0, 0); }
      }
      ctx.restore();
    }

    var raf, running = true, lastFw = 0;
    function frame(now) {
      if (!running) return;
      ctx.clearRect(0, 0, W, H);
      var stopping = dur && now - t0 > dur, alive = 0, k, p;
      for (k = 0; k < parts.length; k++) {
        p = parts[k];
        p.ph += .015 * p.sw; p.r += p.vr; p.fl += p.vf;
        p.y += type === "bubbles" ? -Math.abs(p.vy) : p.vy;
        p.x += p.vx + (wind ? Math.sin(p.ph) * .6 * p.sw : 0);
        if (fog) { p.y = H - 60 + Math.sin(p.ph) * 30; if (p.x - p.s > W) p.x = -p.s; }
        var out = type === "bubbles" ? p.y < -40 : p.y > H + 40;
        if (out || p.x < -80 || p.x > W + 80) { if (stopping) { p.dead = true; continue; } var n = mk(false); if (type === "bubbles") n.y = H + 30; parts[k] = n; p = n; }
        if (p.dead) continue;
        alive++; draw(p);
      }
      if ((P.fireworks || type === "fireworks") && !stopping && now - lastFw > 1300) { firework(); lastFw = now; }
      for (k = fw.length - 1; k >= 0; k--) {
        var f = fw[k]; f.x += f.vx; f.y += f.vy; f.vy += .035; f.l -= .012;
        if (f.l <= 0) { fw.splice(k, 1); continue; }
        ctx.globalAlpha = f.l; ctx.fillStyle = f.c; ctx.beginPath(); ctx.arc(f.x, f.y, 2.2, 0, 6.283); ctx.fill();
      }
      ctx.globalAlpha = 1;
      if (stopping && !alive && !fw.length) { running = false; cv.remove(); return; }
      raf = requestAnimationFrame(frame);
    }
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) { running = false; cancelAnimationFrame(raf); }
      else if (!running && cv.isConnected) { running = true; raf = requestAnimationFrame(frame); }
    });
    raf = requestAnimationFrame(frame);
  }

  function init() {
    build();
    var fallOn = Q ? true : F.enabled !== false;
    var type = !F.type || F.type === "auto" ? P.fall : F.type;
    if (F.custom && String(F.custom).trim()) type = "custom";
    if (fallOn) startFall(type);
    else if (P.fireworks) startFall("none_fw");
  }
  window.CBSeasonal = { presets: Object.keys(PRESETS), preset: presetKey, destroy: function () { nodes.forEach(function (n) { n.remove(); }); st.remove(); } };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
